const uri = "https://helping-hand-api-production.up.railway.app";

export default uri;
